import React from 'react'

interface PaymentSectionProps {
    children?: React.ReactNode
    onProceed: () => void
    onToggle: () => void
}

const PaymentSection: React.FC<PaymentSectionProps> = ({ children, onProceed, onToggle }) => (
    <>
        <div className="subscription__alert" role="alert">
            <div className="d-flex align-items-center"> 
                <div className="">
                    <img src="/assets/info.svg" alt="" className='subscription__alert--icon'/>
                </div>
                <div >
                  <div className="">Your payment will be processed via Paystack. Additional transaction fees may apply</div>
                </div>
            </div>
        </div>
        <div>
            {children}
            <div className="mt-5">
                <button className="subscription__plansDetails--payment" onClick={onProceed}>
                    Proceed to Payment
                </button>
            </div>
            <div className="">
                <button onClick={onToggle} className="subscription__plansDetails--button">
                    Toggle Extras
                </button>
            </div>
        </div>
    </>
)

export default PaymentSection
